import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/**
 * Exports stock movement data to a multi-sheet Excel file.
 */
export const exportStockMovementToExcel = (reportData, filters, productList) => {
    const grnList = reportData.grnList || [];
    const transList = reportData.transList || [];
    const adjustList = reportData.adjustList || [];
    const orderList = reportData.orderList || [];

    const isDataAvailable = grnList.length || transList.length || adjustList.length || orderList.length;
    if (!isDataAvailable) return false;

    const wb = XLSX.utils.book_new();

    // ✅ 1. Summary Sheet
    const summaryData = [
        { Category: "Total GRN Qty", Value: reportData.sumGrnQty ?? 0 },
        { Category: "Total Transfer Qty", Value: reportData.sumTransQty ?? 0 },
        { Category: "Total Adjustment Qty (Addition)", Value: reportData.sumAdjustAddQty ?? 0 },
        { Category: "Total Adjustment Qty (Minus)", Value: reportData.sumAdjustMinQty ?? 0 },
        { Category: "Total Order Qty", Value: reportData.sumOrderQty ?? 0 },
    ];
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(summaryData), "Summary");

    // ✅ 2. GRN Details
    if (grnList.length > 0) {
        const grnWs = XLSX.utils.json_to_sheet(
            grnList.map((item) => ({
                "GRN Ref": item.grN_REF ?? "",
                "Stock": item.stocK_NAME ?? "",
                "GRN Qty": item.grN_QTY ?? 0,
                "Cost": item.grN_COST ?? 0,
                "Total": item.grN_TOTAL ?? 0,
            }))
        );
        XLSX.utils.book_append_sheet(wb, grnWs, "GRN Details");
    }

    // ✅ 3. Transfer Details
    if (transList.length > 0) {
        const transferWs = XLSX.utils.json_to_sheet(
            transList.map((item) => ({
                "Transfer Ref": item.tranS_REF ?? "",
                "From Stock": item.fromstock ?? "",
                "To Stock": item.tostock ?? "",
                "Transfer Qty": item.tranS_QTY ?? 0,
            }))
        );
        XLSX.utils.book_append_sheet(wb, transferWs, "Transfer Details");
    }

    // ✅ 4. Adjustment Details
    if (adjustList.length > 0) {
        const adjustmentWs = XLSX.utils.json_to_sheet(
            adjustList.map((item) => ({
                "Date": item.cR_DT ? new Date(item.cR_DT).toLocaleString() : "",
                "Stock": item.stocK_NAME ?? "",
                "Type": item.adjusT_TYPE ?? "",
                "Adjust Qty": item.adjusT_QTY ?? 0,
                "Note": (item.adjusT_NOTE || "").replace(/<[^>]*>/g, ""),
            }))
        );
        XLSX.utils.book_append_sheet(wb, adjustmentWs, "Adjustment Details");
    }

    // ✅ 5. Order Details
    if (orderList.length > 0) {
        const orderWs = XLSX.utils.json_to_sheet(
            orderList.map((item) => ({
                "Order Ref": item.ordeR_REF ?? "",
                "Order Qty": item.ordeR_QTY ?? 0,
                "Subtotal": item.ordeR_SUBTOTAL ?? 0,
            }))
        );
        XLSX.utils.book_append_sheet(wb, orderWs, "Order Details");
    }

    // ✅ Filename
    const { year, month, productId } = filters;
    const productName = productList.find(p => p.id === productId)?.label || 'Product';
    const formattedMonth = String(month).padStart(2, '0');
    const fileName = `StockMovement_${productName.replace(/\s+/g, '_')}_${year}-${formattedMonth}.xlsx`;

    // ✅ Export
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);

    return true;
};
